import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import {Route, Router, Switch } from 'react-router-dom';
import "./css/index.css";
import App from "./components/App/App";
import * as serviceWorker from "./serviceWorker";
import "./Authentication/Auth";

const allSettled = require("promise.allsettled");

allSettled.shim();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
